@if (cultures$ | async; as cultures) {
  <form [formGroup]="form">
    <mat-form-field>
      <mat-select placeholder="Choose culture" formControlName="culture">
        @for (culture of cultures; track culture) {
          <mat-option [value]="culture">
            {{culture.Culture}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>
}
